<template>
    <div class="footer">
        <div class="has-text-centered has-text-secondary">
            A little project by
            <a href="https://x.com/benedictbartsch" target="_blank" rel="noopener noreferrer">
                <span class="icon-text">
                    <span class="icon">
                        <FontAwesomeIcon :icon="faXTwitter" />
                    </span>
                    <span>@benedictbartsch</span>
                </span>
            </a>.
            <p class="my-6 is-size-7">
                <span>© {{ currentYear }} Benedict Bartsch</span>
                <span class="mx-4"><a href="https://startpunkt.io/imprint" target="_blank" rel="noopener noreferrer">Legal notice</a></span>
                <span class="mx-4"><a href="https://startpunkt.io/timist-blocks/terms/" target="_blank" rel="noopener noreferrer">Terms</a></span>
                <span class="mx-4"><a href="https://startpunkt.io/timist-blocks/privacy/" target="_blank" rel="noopener noreferrer">Privacy</a></span>
                <span class="mx-4"><a href="https://status.timist.app" target="_blank" rel="noopener noreferrer">Status</a></span>
            </p>
            <div class="mt-2">
                <p class="is-size-7 has-text-secondary" style="opacity: 0.5;">{{ version }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { ref, onMounted, computed } from 'vue';

// Version is injected as a meta tag by Rails layout using config.app_version
const version = ref('');
const currentYear = computed(() => new Date().getFullYear());

onMounted(() => {
    const meta = document.querySelector('meta[name="app-version"]');
    version.value = meta?.content || '';
});
</script>

<style scoped>
.footer p span {
    color: #4a4a4a;
}
</style>